import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { LiraAdvContainer } from '@sbt-web/adv';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';
export const AdsZeroPageBlock = function (t0) {
  const $ = _c(4);
  const {
    cssClass
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp2, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LiraAdvContainer style={{
      display: "block"
    }} idForAd={LiraContainerIds.listing.zeroResult} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== cssClass) {
    t3 = <div className={cssClass}>{t2}</div>;
    $[2] = cssClass;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp() {
  window.liraSdk.fetchLazyLoadAd([LiraContainerIds.listing.zeroResult]);
}
function _temp2() {
  window.liraSDKQueue?.push(_temp);
}